import { useNavigate } from "react-router-dom";
import SEO from "@/components/SEO";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <SEO title="Sayfa Bulunamadı | isbul.org" description="Aradığınız sayfa bulunamadı." />
      <Header />
      <div className="max-w-xl mx-auto px-4 py-32 text-center">
        <h1 className="text-7xl font-extrabold text-blue-600">404</h1>
        <p className="text-xl font-semibold text-[#1f222d] mt-4">Sayfa bulunamadı</p>
        <p className="text-slate-500 mt-2">Aradığınız sayfa taşınmış veya hiç var olmamış olabilir.</p>
        <Button data-testid="notfound-home" onClick={() => navigate("/")} className="mt-8 bg-blue-600 hover:bg-blue-700 text-white rounded-full px-8 py-6">Ana Sayfaya Dön</Button>
      </div>
      <Footer />
    </div>
  );
}
